import { DebugPanel, makePersistent, Storage } from '@wix/debug-panel';

export const debugSettings = makePersistent(
  {
    name: 'WixTestBit',
  },
  new Storage('bandsintown'),
);

export const debugPanel = new DebugPanel(debugSettings, {
  schema: {
    name: {
      key: 'name',
      type: String,
      title: 'Artist Name',
      persistent: true,
      requiresReload: true,
    },
  },
  version: (window as any).__CI_APP_VERSION__,
  showGeneralInfo: true,
  experimentOptions: {
    experiments: [],
  },
});
